import { setScrollbar } from '../common/utils';

export const initScrollBar = () => {
    let scrollBars = document.querySelectorAll(`[data-scrollbar]`);
    setScrollbar(scrollBars);
};

window.initScrollbar = (el) => new window.SimpleBar(el, { autoHide: false });

